import { useState } from "react";
import type { StaffOrderDetail } from "@/api/staff";

interface Props {
  orderInfo: StaffOrderDetail;
}

export function FeeDetailBar({ orderInfo }: Props) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="bg-white rounded-2xl overflow-hidden shadow-sm">
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between px-4 py-3.5 active:bg-gray-50"
      >
        <span className="text-sm font-bold text-gray-900">费用明细</span>
        <div className="flex items-center gap-2">
          <span className="text-base font-bold text-[#FE7A3A]">¥{orderInfo.pay_price || orderInfo.original_price || "0"}</span>
          <i className={`ri-arrow-down-s-line text-gray-400 text-sm transition-transform ${expanded ? "rotate-180" : ""}`} />
        </div>
      </button>

      {expanded && (
        <div className="px-4 pb-4 space-y-2 text-sm border-t border-gray-50">
          <FeeRow label="订单金额" value={`¥${orderInfo.original_price || "0"}`} />
          {Number(orderInfo.fare || 0) > 0 && <FeeRow label="出行费用" value={`¥${orderInfo.fare}`} />}
          <FeeRow label="实付金额" value={`¥${orderInfo.pay_price || orderInfo.original_price || "0"}`} highlight />
          <FeeRow label="预计收益" value={`¥${orderInfo.cost_fee_sum || "0"}`} highlight />
        </div>
      )}
    </div>
  );
}

function FeeRow({ label, value, highlight }: { label: string; value: string; highlight?: boolean }) {
  return (
    <div className="flex justify-between py-1.5">
      <span className="text-gray-500">{label}</span>
      <span className={highlight ? "font-bold text-gray-900" : "text-gray-700"}>{value}</span>
    </div>
  );
}
